import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';
import { FILTER_VALUES, APPROVED_GL_POSTING_FILTER_PARAMS } from '../../constants/FilterConstants';
import { LAST_UPDATED_DESC } from '../../constants/SortConstants';

export const defaultApprovedFilterState = {
  ...APPROVED_GL_POSTING_FILTER_PARAMS,
  searchText: '',
  pageNumber: DEFAULT_PAGE,
  rowsPerPage: DEFAULT_PER_PAGE,
  sort: LAST_UPDATED_DESC,
};

const initialState = {
  approvedGLPosting: { ...defaultApprovedFilterState },
};

export const weeklyGLPostingFiltersSlice = createSlice({
  name: 'weeklyGLPostingFilters',
  initialState,
  reducers: {
    setApprovedGLPostingFilters(state, action) {
      state.approvedGLPosting[FILTER_VALUES.CREATED_BY] = action.payload?.[FILTER_VALUES.CREATED_BY] || [];
      state.approvedGLPosting[FILTER_VALUES.PRODUCT_TYPE] = action.payload?.[FILTER_VALUES.PRODUCT_TYPE] || [];
      state.approvedGLPosting[FILTER_VALUES.START_DATE] = action.payload?.[FILTER_VALUES.START_DATE] || '';
      state.approvedGLPosting[FILTER_VALUES.END_DATE] = action.payload?.[FILTER_VALUES.END_DATE] || '';
      state.approvedGLPosting.searchText = action.payload?.searchText || '';
      state.approvedGLPosting.pageNumber = action.payload?.pageNumber || DEFAULT_PAGE;
      state.approvedGLPosting.rowsPerPage = action.payload?.rowsPerPage || DEFAULT_PER_PAGE;
      state.approvedGLPosting.sort = action.payload?.sort || LAST_UPDATED_DESC;
    },
    resetApprovedGLPostingFiltersState(state) {
      const currentSearchText = state.approvedGLPosting?.searchText || '';
      const currentSort = state.approvedGLPosting?.sort || LAST_UPDATED_DESC;
      state.approvedGLPosting = {
        ...defaultApprovedFilterState,
        searchText: currentSearchText,
        sort: currentSort,
      };
    },
  },
});

export default weeklyGLPostingFiltersSlice;
